
export const START_OF_TIME = new Date(1970, 1, 1, 0, 0, 0);
export const DISABLED_FROM_TODAY_DURATION = {days: 14};
export const RESERVATION_REQUEST_TIMEOUT_DURATION = {days: 3};
export const RESERVATION_CHECKOUT_TIMEOUT_DURATION = {days: 1};
